import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DialogCloseButton } from 'components/common/DialogCloseButton';
import { EventSettings, EventSettingsProps } from 'components/event/EventSettings';
import { EventOccasion } from 'models/EventOccasion';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'

export interface EventSettingsDialogProps extends EventSettingsProps {
  open: boolean;
  focusElement?: HTMLElement;
  onCancel?: (ev: React.MouseEvent) => void;
  onSave?(event: Partial<EventOccasion>): void;
}

export function EventSettingsDialog(props: EventSettingsDialogProps) {
  const { t } = useTranslation()
  const [event, setEvent] = useState(props.event);
  const isValid = !!(event?.name && event?.date && event?.expireDate);

  const handleChange = (values: Partial<EventOccasion>) => {
    const newEvent = { ...event, ...values };
    setEvent(newEvent);
    props.onChange?.(newEvent);
  };

  const handleCloseDialog = (ev: React.MouseEvent) => {
    props.onCancel?.(ev);
  };

  const handleSave = () => {
    if (event) {
      props.onSave?.(event);
    }
  };

  return (
    <Dialog open={props.open} onClose={handleCloseDialog} fullWidth maxWidth="sm">
      <DialogTitle variant="h3">{t('eventDetails', 'Event Details')}</DialogTitle>
      <DialogCloseButton onClose={handleCloseDialog} />
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <EventSettings onChange={handleChange} event={event} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={handleCloseDialog}>
          {t('cancel', 'Cancel')}
        </Button>
        <Button variant="contained" onClick={handleSave} disabled={!isValid || props.isSaving}>
          {props.isSaving ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
